import React from 'react';
import {Attachment, MessageResponse} from 'stream-chat';
import {
  Container,
  InnerContainer,
  DateText,
  FogMessage,
  MessageText,
  MessageContainer,
} from './styles';
import {theme} from '../../../styles/darkTheme';
import {
  REQUEST_REMITTANCE,
  SEND_REMITTANCE,
  TYPES_ATTACHMENT,
} from '../../../utils/constants';
import {useTranslation} from '../../../context/language';
import moment from 'moment';
import UserAvatar from '../UserAvatar';
import RemittanceAttachment from '../RemittanceAttachment';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {SET_REMITTANCE} from '../../../redux/actionTypes';

interface Props extends MessageResponse {
  fromCurrentUser?: boolean;
}

const MessageCard: React.FC<Props> = ({
  id,
  created_at = new Date().toISOString(),
  fromCurrentUser,
  user,
  text,
  attachments,
}) => {
  const {text: t} = useTranslation();
  const history = useNavigate();
  const date = new Date(created_at || '');
  const dispatch = useDispatch()

  const hasAttachments: boolean =
    attachments != undefined && attachments.length > 0;

  const getDate = (someDate: Date): string => {
    const today = new Date();
    if (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    ) {
      return t.today + ' ' + moment(date).format('h:mm a');
    }

    return moment(date).format('DD/MM/YYYY h:mm a');
  };
  const handleClickDetails = (props: Attachment) => {
    const mockData = {
      senderPhone: {
        dialCountryCode: '+1',
        mobileNumber: '6505551111'
      }
    }
    dispatch({ type: SET_REMITTANCE, payload: mockData });
    history(`/details?id=${props.id}&action=${props.type}`);
  };

  const typesAttachments = {
    [TYPES_ATTACHMENT.remittance]: (props: Attachment & {key: string}) => (
      <RemittanceAttachment
        key={props.key}
        isCurrentUser={fromCurrentUser}
        //@ts-ignore
        id={props.id}
        //@ts-ignore
        amount={props.amount}
        //@ts-ignore
        convertedAmount={props.convertedAmount}
        type={SEND_REMITTANCE}
        onClick={() => handleClickDetails(props)}
      />
    ),
    [TYPES_ATTACHMENT.request_remittance]: (
      props: Attachment & {key: string},
    ) => (
      <RemittanceAttachment
        key={props.key}
        isCurrentUser={fromCurrentUser}
        //@ts-ignore
        id={props.id}
        //@ts-ignore
        amount={props.amount}
        //@ts-ignore
        reason={props.concept}
        type={REQUEST_REMITTANCE}
        onClick={() => handleClickDetails(props)}
      />
    ),
  };

  return (
    <Container
      isCurrentUser={fromCurrentUser}
      hasAttachments={attachments && attachments.length > 0}>
      <InnerContainer>
        {!fromCurrentUser && (
          <UserAvatar
            src={(user && (user.avatar as string)) || undefined}
            size={40}
          />
        )}
        <MessageContainer isCurrentUser={fromCurrentUser}>
          <DateText theme={theme} isCurrentUser={fromCurrentUser}>
            {getDate(date)}
          </DateText>
          <FogMessage
            isCurrentUser={fromCurrentUser}
            hasAttachments={attachments && attachments.length > 0}
            theme={theme}>
            {attachments?.map((item, i) => {
              //@ts-ignore
              return item.type && typesAttachments[item.type]
                ? //@ts-ignore
                  typesAttachments[item.type]({
                    key: i,
                    onPress: () => console.log('a'),
                    ...item,
                  })
                : null;
            })}
            {text &&
              (!hasAttachments ||
                (attachments &&
                  attachments[0].type !== TYPES_ATTACHMENT.remittance &&
                  attachments[0].type !==
                    TYPES_ATTACHMENT.request_remittance)) && (
                <MessageText theme={theme} isCurrentUser={fromCurrentUser}>
                  {text}
                </MessageText>
              )}
          </FogMessage>
        </MessageContainer>
      </InnerContainer>
    </Container>
  );
};

export default MessageCard;
